import { Link, useLocation } from 'react-router-dom';
import { buildBreadcrumbs } from '../experience/navigation';

export function Breadcrumbs() {
  const location = useLocation();
  const depth = location.pathname.split('/').filter(Boolean).length;
  // Top-level pages are named by the sidebar already; a one-hop trail is noise.
  if (depth <= 1) return null;
  const crumbs = buildBreadcrumbs(location.pathname);
  if (crumbs.length <= 1) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-[var(--shell-fg-muted)]">
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <li key={crumb.path} className="flex items-center gap-1">
              {i > 0 && (
                <span aria-hidden="true" className="text-[var(--shell-fg-subtle)]">
                  /
                </span>
              )}
              {isLast ? (
                <span aria-current="page" className="font-medium capitalize text-[var(--shell-fg)]">
                  {crumb.label}
                </span>
              ) : (
                <Link to={crumb.path} className="capitalize hover:text-[var(--shell-accent)]">
                  {crumb.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
